import { render, staticRenderFns } from "./shopCarPoint.vue?vue&type=template&id=5801513f&scoped=true&"
import script from "./shopCarPoint.vue?vue&type=script&lang=js&"
export * from "./shopCarPoint.vue?vue&type=script&lang=js&"
import style0 from "./shopCarPoint.vue?vue&type=style&index=0&id=5801513f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5801513f",
  null
  
)

export default component.exports